import { AuthService } from './features/auth/auth.service';
import { VersionService } from './shared/services/version.service';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MessageInstallPwaComponent } from './shared/components/message-install-pwa/message-install-pwa.component';
import { SwUpdate } from '@angular/service-worker';
import { DarkModeService } from './shared/services/dark-mode.service';
import { environment } from '../environments/environment';
import { filter } from 'rxjs';
import { GetPermissionsAction } from './core/actions/get-permissions.action';
import { GetDiskUsageAction } from './domains/Checklist/Actions/get-disk-usage.action';
import { CommonModule } from '@angular/common';
import { CountDataMenuAction } from './core/actions/count-data-menu.action';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MessageInstallPwaComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  darkModeService = inject(DarkModeService);
  router = inject(Router);
  getPermissionsAction = inject(GetPermissionsAction);
  countDataMenuAction = inject(CountDataMenuAction);

  envMode = environment.mode;

  storageWarning = '';

  constructor(
    private authService: AuthService,
    private updates: SwUpdate,
    private versionService: VersionService,
  ) {}

  ngOnInit(): void {
    this.authService.startTokenRefreshCountdown();
    this.darkModeService.initialize();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const isOutsideApp =
          event.url === '/login' ||
          event.urlAfterRedirects === '/login' ||
          event.url === '/auth/logou' ||
          event.urlAfterRedirects === '/auth/logou' ||
          event.url === '/' ||
          event.urlAfterRedirects === '/';

        if (!isOutsideApp) {
          this.checkAndSavePermissions();
          this.countDataMenu();
        }
      });

    if (this.updates.isEnabled) {
      this.updates.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.promptUserForUpdate();
        }
      });
    }
  }

  promptUserForUpdate(): void {
    const userConfirmed = window.confirm(
      `Nova versão disponível! Deseja atualizar agora? Versão atual: (${this.versionService.get})`,
    );

    if (userConfirmed) {
      this.updates.activateUpdate().then(() => document.location.reload());
    }
  }

  private countDataMenu() {
    const branch_uuid = this.authService.branch?.uuid;

    if (!branch_uuid) return;

    this.countDataMenuAction.execute(branch_uuid).subscribe((response) => {
      const data = JSON.stringify(response.data);
      localStorage.setItem('countDataMenu', data);
    });
  }

  private checkAndSavePermissions() {
    this.getPermissionsAction.execute().subscribe((response) => {
      const me = JSON.parse(localStorage.getItem('me')!);
      const roles = me.roles || [];

      me.roles = response.data;

      localStorage.setItem('me', JSON.stringify(me));
    });
  }

  private checkStorageStatus(): void {
    const data = localStorage.getItem('diskUsage');
    if (!data) return;

    const parsed = JSON.parse(data);
    const serverPercent = parseFloat(parsed.checklist.percent_used || '0');

    if (serverPercent >= 80) {
      this.storageWarning = `Servidor está com ${serverPercent}% de uso (${parsed.server.used_space} de ${parsed.server.total_space})`;
    } else {
      this.storageWarning = '';
    }
  }
}
